export default __webpack_public_path__ + "static/media/brand-features.212c2cd6.svg";